import {JsxVNode, JsxVNodeChild, JsxVNodeChildren} from 'snabbdom-jsx-lite';

export const JSX_CHILDREN_PROP = `$children`;

function isJsxChildrenArray(jsxChildren: JsxVNodeChildren): jsxChildren is JsxVNodeChild[] {
  return Array.isArray(jsxChildren);
}
function isChildVNode(jsxChild: JsxVNodeChild): jsxChild is JsxVNode {
  return typeof !!jsxChild && typeof jsxChild === `object`;
}
export function getVirtualSlotChildren(jsxChildren: JsxVNodeChildren, slotName: string): JsxVNode[] {
  const results: JsxVNode[] = [];
  const breadthQueue: JsxVNodeChild[] = isJsxChildrenArray(jsxChildren) ? [...jsxChildren] : [jsxChildren];
  while (breadthQueue.length > 0) {
    const child = breadthQueue.shift();
    if (isChildVNode(child)) {
      if ((child.data?.attrs?.slot || ``) === (slotName || ``)) {
        results.push(child);
      } else if (child.children) {
        for (const nextChild of child.children) {
          breadthQueue.push(nextChild);
        }
      }
    }
  }
  return results;
}
